import React from 'react';
import {
  Box,
  Stack,
  Tooltip,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { AlertInfoIcon } from '@fortress-technology-solutions/fortress-component-library/Icons';
import messages from '../messages';
import type { Props } from './types';

function DecisionNeededCaption({ intl }: Props) {
  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          backgroundColor: 'primary.main',
        }}
      />
      <Typography
        variant="labelMedium"
        color="primary.main"
        sx={{ fontWeight: 500 }}
      >
        {intl.formatMessage(messages.decisionNeeded)}
      </Typography>
      <Tooltip
        title={intl.formatMessage(messages.decisionNeededInfo)}
        placement="top"
      >
        <span>
          <AlertInfoIcon fontSize="small" color="primary" />
        </span>
      </Tooltip>
    </Stack>
  );
}

export default DecisionNeededCaption;
